import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ThemeModeProvider } from './theme';

// Pages
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import AccountsPage from './pages/AccountsPage';
import AutoLikerPage from './pages/AutoLikerPage';
import AutoCommenterPage from './pages/AutoCommenterPage';
import AutoSubscriberPage from './pages/AutoSubscriberPage';
import HistoryPage from './pages/HistoryPage';
import BillingPage from './pages/BillingPage';
import AdminPage from './pages/AdminPage';
import ProfilePage from './pages/ProfilePage';
import ReferralPage from './pages/ReferralPage';

// Layout
import Layout from './components/Layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <ThemeModeProvider>
      <Toaster position="top-right" />
      <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, '')}>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          {/* Protected routes */}
          <Route path="/dashboard" element={<ProtectedRoute><Layout><DashboardPage /></Layout></ProtectedRoute>} />
          <Route path="/accounts" element={<ProtectedRoute><Layout><AccountsPage /></Layout></ProtectedRoute>} />
          <Route path="/auto-liker" element={<ProtectedRoute><Layout><AutoLikerPage /></Layout></ProtectedRoute>} />
          <Route path="/auto-commenter" element={<ProtectedRoute><Layout><AutoCommenterPage /></Layout></ProtectedRoute>} />
          <Route path="/auto-subscriber" element={<ProtectedRoute><Layout><AutoSubscriberPage /></Layout></ProtectedRoute>} />
          <Route path="/history" element={<ProtectedRoute><Layout><HistoryPage /></Layout></ProtectedRoute>} />
          <Route path="/billing" element={<ProtectedRoute><Layout><BillingPage /></Layout></ProtectedRoute>} />
          <Route path="/billing/success" element={<ProtectedRoute><Layout><BillingPage /></Layout></ProtectedRoute>} />
          <Route path="/billing/fail" element={<ProtectedRoute><Layout><BillingPage /></Layout></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Layout><ProfilePage /></Layout></ProtectedRoute>} />
          <Route path="/referral" element={<ProtectedRoute><Layout><ReferralPage /></Layout></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><Layout><AdminPage /></Layout></ProtectedRoute>} />

          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
    </ThemeModeProvider>
  );
}

export default App;
